<template>
  <Teleport to="body" v-if="showTaskSwitch">
    <!-- 任务 -->
    <FloatingBubble axis="xy" magnetic="x" v-model:offset="offset" @click="openDrawer">
      <div class="task-btn">
        <img src="@/assets/images/taskBtn.png" alt="" srcset="" />
      </div>
    </FloatingBubble>

    <!-- 任务浮窗 -->
    <van-popup v-model:show="isDrawerOpen" position="bottom" round lock-scroll :close-on-click-overlay="false">
      <div class="task_change">
        <div class="task_change_name">
          <div class="task_title" v-if="taskStatus === 200">
            <!-- 你已通过本任务 -->
            <i class="iconfont icon-icon_wode_wodepeixun_wancheng sucessful_icon" /> {{ $t('app_pass_task') }}
          </div>
          <div class="task_title" v-else>
            <i class="iconfont icon-icon_ketang_kechengbao_weikaishi studying_icon" />{{ $t('app_in_task') }}
          </div>
          <div @click="closeDrawer"><i class="iconfont icon-icon_wode_wodepeixun_guanbi close_icon" /></div>
        </div>
        <div class="task_num">
          <!-- 当前是第几个任务，共几个 -->
          {{ formatLang(t('app_currtask_index'), [Number(currentTaskIndex) + 1, trainingTaskList.length]) }}
        </div>

        <div class="task_button">
          <!-- 返回任务列表按钮 -->
          <div @click="goBack">
            <div class="task_back">
              <i class="iconfont icon-icon_wode_wodepeixun_fanhuiliebiao1 back_icon"></i>
            </div>
            <div class="task_list">{{ $t('app_return_to_tasklist') }}</div>
          </div>

          <!-- 任务切换按钮 -->
          <div>
            <div v-if="!isLastTask" class="next_task" @click="switchToNextTask">
              <i class="iconfont icon-icon_wode_wodepeixun_xiayirenwu next_icon"></i>
            </div>
            <div v-if="isLastTask" class="last_task" @click="switchToNextTask">
              <i class="iconfont icon-icon_wode_wodepeixun_xiayirenwu next_icon"></i>
            </div>
            <!-- 下一个任务 -->
            <div v-if="!isLastTask" class="task_list" @click="switchToNextTask">{{ $t('app_next_task') }}</div>
            <!-- 已是最后一个任务 -->
            <div v-if="isLastTask" class="task_last_list">{{ $t('app_last_task') }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { getTrainingTask, getTrainingUpdate } from '@/api/requests/TrainingRequests'
import { useRouter, useRoute } from 'vue-router'
import { formatLang } from '@/utils/format'
import { useTaskStore } from '@/stores/task'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { showToast, FloatingBubble } from 'vant'

const { t } = useI18n()
const taskStore = useTaskStore()
const { showTaskSwitch } = storeToRefs(taskStore)
const route = useRoute()
const router = useRouter()
const { availWidth, availHeight } = window.screen
const offset = ref({ x: availWidth - 72, y: availHeight - 250 })
const trainingTaskType = ref(route.query?.taskType)
const trainingId = ref(route.query?.trainingId)
const trainingTaskId = ref(route.query?.taskId)
const globalIndex = ref(route.query?.globalIndex)

const selectedTask = ref(true)
const isDrawerOpen = ref(false)
const trainingTaskList = ref()
const currentTaskIndex = ref(null)
const taskStatus = ref()
const isLastTask = ref(false)
// const { availWidth, availHeight } = window.screen
// const offset = ref({ x: availWidth - 60, y: availHeight - 142 })

const openDrawer = () => {
  selectedTask.value = false
  isDrawerOpen.value = true
}

const getTrainingTaskFunc = async () => {
  if (trainingId.value && globalIndex.value != null) {
    const { data, code } = await getTrainingTask({ trainingId: trainingId.value })
    if (code === 1) {
      trainingTaskList.value = data
      if (trainingTaskList.value) {
        trainingTaskList.value.forEach((element, index) => {
          if (Number(globalIndex.value) === element.globalIndex) {
            currentTaskIndex.value = index
            taskStatus.value = element.status
            // 最后一个任务
            if (index + 1 === trainingTaskList.value.length) {
              isLastTask.value = true
            }
          }
        })
      }
      // console.log(currentTaskIndex.value, trainingTaskList.value.length, '已是最后一个任务')
    }
  }
}

watch(
  () => [route.query?.globalIndex, route.query?.taskType, route.query?.trainingId, route.query?.taskId],
  (newVal) => {
    isDrawerOpen.value = false
    globalIndex.value = newVal[0]
    trainingTaskType.value = newVal[1]
    trainingId.value = newVal[2]
    trainingTaskId.value = newVal[3]
    isLastTask.value = false
    getTrainingTaskFunc()
  },
  { immediate: true }
)

const closeDrawer = () => {
  selectedTask.value = true
  isDrawerOpen.value = false
}

const goBack = () => {
  router.go(-1)
}

const switchToNextTask = async () => {
  await getTrainingTaskFunc()

  if (trainingTaskList.value) {
    const nextTaskIndex = Number(currentTaskIndex.value) + 1
    if (nextTaskIndex < trainingTaskList.value.length) {
      const nextTask = trainingTaskList.value[nextTaskIndex]
      // console.log('相同的index', nextTask, nextTask.taskType)
      // 当前任务未完成，下个任务未解锁，提示请先完成本任务
      if (trainingTaskList.value[nextTaskIndex].lockStatus === 1) {
        showToast(t('app_current_task_first'))
        return
      }
      /* 已删除课程 不显示悬浮任务 */
      if (nextTask.isRefDeleted && nextTask.isRefDeleted === 1) {
        selectedTask.value = false
      }

      if (nextTask.taskType === 1 || nextTask.taskType === 2) {
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'courseDetail',
          query: {
            id: nextTask.taskId,
            endingType: 0,
            channel: 3,
            courseType: nextTask.taskType === 1 ? 'course' : 'courseWare',
            trainingId: nextTask.trainingId,
            globalIndex: nextTask.globalIndex
          }
        })
      } else if (nextTask.taskType === 3) {
        // 考试
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'ExamInfo',
          query: { examId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 4) {
        // 调查
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        // 调查
        if (nextTask.status === 200) {
          router.replace({
            name: 'surveyDetails',
            query: {
              investigationId: nextTask.taskId,
              trainingId: nextTask.trainingId,
              globalIndex: nextTask.globalIndex
            }
          })
        } else {
          router.replace({
            name: 'surveyInfo',
            query: {
              investigationId: nextTask.taskId,
              trainingId: nextTask.trainingId,
              globalIndex: nextTask.globalIndex
            }
          })
        }
      } else if (nextTask.taskType === 5) {
        // 作业未开始
        // 作业已结束
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'TrainingHomework',
          query: { taskId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 6) {
        // 签到
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'SignTask',
          query: { taskId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 7) {
        // 链接
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'LinkTask',
          query: { taskId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 8) {
        // 练习
        router.replace({
          name: 'ExamPractiseInfo',
          query: {
            practiseId: nextTask.taskId,
            trainingId: nextTask.trainingId,
            globalIndex: nextTask.globalIndex
          }
        })
      } else if (nextTask.taskType === 9) {
        router.replace({
          name: 'faceDetail',
          query: {
            faceId: nextTask.taskId,
            trainingId: nextTask.trainingId,
            globalIndex: nextTask.globalIndex
          }
        })
      } else if (nextTask.taskType === 10) {
        // 其他
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'OtherTraining',
          query: { taskId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 11) {
        // 签署任务
        if (nextTask.startTime && nextTask.endTime) {
          const now = Date.now()
          const start = new Date(nextTask.startTime).getTime()
          const end = new Date(nextTask.endTime).getTime()

          if (now < start) {
            // 未开始
            showToast(formatLang(t('app_sign_task_not_start'), [nextTask.startTime, nextTask.endTime]))
            return
          } else if (now > end) {
            // 已结束
            showToast(formatLang(t('app_sign_task_ended'), [nextTask.startTime, nextTask.endTime]))
            return
          }
        }
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'signDetail',
          query: { trainConfirmId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      }
      selectedTask.value = true
      isDrawerOpen.value = false
      currentTaskIndex.value = nextTaskIndex
    } else {
      // 最后一个任务
      showToast(t('app_last_task'))
    }
  }
}
</script>

<style scoped lang="less">
.task-btn {
  img {
    width: 48px;
    height: 48px;
  }
}

.task_change {
  padding: 16px 16px 36px;

  .task_change_name {
    display: flex;
    justify-content: space-between;

    .task_title {
      margin-left: 29%;
    }

    .close_icon {
      font-size: 12px;
    }

    .sucessful_icon {
      color: #0fc030;
      font-size: 19px;
      margin-right: 6px;
    }

    .studying_icon {
      color: #f39b00;
      font-size: 19px;
      margin-right: 6px;
    }
  }

  .task_num {
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #999999;
    padding: 8px 16px;
  }

  .task_button {
    display: flex;
    justify-content: space-around;
  }

  .iconfont {
    color: #171921;
    font-size: 24px;
  }

  .task_back {
    width: 60px;
    height: 60px;
    border: 1px solid #f39b00;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
  }

  .back_icon {
    color: #f39b00;
  }

  .task_list {
    font-size: 12px;
    font-weight: 500;
    color: #171921;
    line-height: 35px;
  }

  .task_last_list {
    font-size: 12px;
    font-weight: 500;
    color: #171921;
    line-height: 35px;
    margin-left: -15px;
  }

  .next_task {
    width: 60px;
    height: 60px;
    border: 1px solid #f39b00;
    background: #f39b00;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .last_task {
    width: 60px;
    height: 60px;
    border: 1px solid #b7b7b7;
    background: #b7b7b7;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .next_icon {
    color: #fff;
  }
}
</style>
